<script>

export default {
    props: {
        productId: Number,
    },
    mounted() {
        this.fetchData();
    },
    data() {
        return {
            loading: true,
            loadingField: true,
            product: null,
            languages: null,
        }
    },
    methods: {
        save: function (data) {
            this.loadingField = true;
            axios.post(`${Scoop.baseUrl}/productText`, data).then(res => {
                this.product = res.data.product;
                this.loadingField = false;
            }).catch(error => {
                this.loadingField = false;
                console.log(error);
            });
        },
        fetchData: function () {
            if (this.product === null) {
                axios.get(`${Scoop.baseUrl}/productText/${this.productId}`).then(res => {
                    this.product = res.data.product;
                    this.languages = res.data.languages;
                    this.loading = false;
                    this.loadingField = false;

                    this.$nextTick(() => {
                        $('.collapse-link').on('click', function () {
                            var ibox = $(this).closest('div.ibox');
                            var button = $(this).find('i');
                            var content = ibox.find('div.ibox-content');
                            content.slideToggle(200);
                            button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                            ibox.toggleClass('').toggleClass('border-bottom');
                            setTimeout(function () {
                                ibox.resize();
                                ibox.find('[id^=map-]').resize();
                            }, 50);
                        });
                    });

                }).catch(error => {
                    this.loadingField = false;
                    console.log(error);
                });
            }
        },
        getText: function (element, typeName) {
            return element.texts[typeName] ? element.texts[typeName].text : ''
        },
        getId: function (element, typeName) {
            return element.texts[typeName] ? element.texts[typeName].id : null
        },
        getTranslation: function (element, language, field) {
            let fieldTranslation = _.head(_.filter(element.translations, function (translation) {
                if (translation.language_id === language.id) {
                    return translation;
                }
            }));

            return fieldTranslation && fieldTranslation[field]
                ? fieldTranslation[field]
                : null;
        },
    },
    computed: {
        hasMoreThanOneVariant() {
            return this.product.variants.length > 1;
        }
    },
}
</script>

<template>
    <div class="product-texts">
        <div class="row" v-if="!loading">
            <!-- Produktname -->
            <autosave-text-field
                    :label="__('product-texts.form.article_name')"
                    :product-id="productId"
                    :text="product.product_name"
                    :loading="loadingField"
                    @text-edited="save"
                    type="product_name"
            />

            <!-- Modellname -->
            <autosave-text-field
                    :label="__('product-texts.form.model_name')"
                    :product-id="productId"
                    :text="product.model_name"
                    :loading="true"
                    type="model_name"
            />

            <!-- Katalog USP Text -->
            <autosave-text-field
                    :label="__('product-texts.form.catalogue_usp_text')"
                    :product-id="productId"
                    :text="getText(product, 'TYPE_CATALOGUE_USP')"
                    :id="getId(product, 'TYPE_CATALOGUE_USP')"
                    type="1"
                    :textarea="true"
                    @text-edited="save"
                    :loading="loadingField"
            />

            <!-- Katalog Benefit 1 Text -->
            <autosave-text-field
                    :label="__('product-texts.form.catalogue_benefit_1_text')"
                    :product-id="productId"
                    :text="getText(product, 'TYPE_CATALOGUE_BENEFIT_1')"
                    :id="getId(product, 'TYPE_CATALOGUE_BENEFIT_1')"
                    type="2"
                    :textarea="true"
                    @text-edited="save"
                    :loading="loadingField"
            />

            <!-- Katalog Benefit 2 Text -->
            <autosave-text-field
                    :label="__('product-texts.form.catalogue_benefit_2_text')"
                    :product-id="productId"
                    :text="getText(product, 'TYPE_CATALOGUE_BENEFIT_2')"
                    :id="getId(product, 'TYPE_CATALOGUE_BENEFIT_2')"
                    type="3"
                    :textarea="true"
                    :loading="loadingField"
                    @text-edited="save"
            />

            <!-- Katalog Benefit 3 Text -->
            <autosave-text-field
                    :label="__('product-texts.form.catalogue_benefit_3_text')"
                    :product-id="productId"
                    :text="getText(product, 'TYPE_CATALOGUE_BENEFIT_3')"
                    :id="getId(product, 'TYPE_CATALOGUE_BENEFIT_3')"
                    type="4"
                    :textarea="true"
                    :loading="loadingField"
                    @text-edited="save"
            />

            <!-- Online Text -->
            <autosave-text-field
                    :label="__('product-texts.form.online_text')"
                    :product-id="productId"
                    :text="getText(product, 'TYPE_ONLINE_TEXT')"
                    :id="getId(product, 'TYPE_ONLINE_TEXT')"
                    type="5"
                    :textarea="true"
                    :loading="loadingField"
                    @text-edited="save"
            />

            <div class="col-sm-12" v-if="hasMoreThanOneVariant"><br></div>

            <div
                    class="col-sm-12"
                    v-for="variant in product.variants"
                    v-if="hasMoreThanOneVariant"
            >
                <div class="ibox collapsed border-left-right border-bottom">
                    <div class="ibox-title">
                        <h5>Variante - {{ __('product-texts.attributes.colorheadline') }} {{ variant.color_name }}</h5>
                        <div class="ibox-tools">
                            <a class="collapse-link" href="" @click.prevent="">
                                <i class="fa fa-chevron-up"></i>
                            </a>
                        </div>
                    </div>
                    <div class="ibox-content border-bottom">
                        <div class="row">
                            <!-- Katalog USP Text -->
                            <autosave-text-field
                                    :label="__('product-texts.form.catalogue_usp_text')"
                                    :product-variant-id="variant.id"
                                    :text="getText(variant, 'TYPE_CATALOGUE_USP')"
                                    :id="getId(variant, 'TYPE_CATALOGUE_USP')"
                                    :placeholder="getText(product, 'TYPE_CATALOGUE_USP')"
                                    type="1"
                                    :textarea="true"
                                    @text-edited="save"
                                    :loading="loadingField"
                                    :key="'catalogue_usp_text' + variant.id"
                            />

                            <!-- Katalog Benefit 1 Text -->
                            <autosave-text-field
                                    :label="__('product-texts.form.catalogue_benefit_1_text')"
                                    :product-variant-id="variant.id"
                                    :text="getText(variant, 'TYPE_CATALOGUE_BENEFIT_1')"
                                    :id="getId(variant, 'TYPE_CATALOGUE_BENEFIT_1')"
                                    :placeholder="getText(product, 'TYPE_CATALOGUE_BENEFIT_1')"
                                    type="2"
                                    :textarea="true"
                                    @text-edited="save"
                                    :loading="loadingField"
                                    :key="'catalogue_benefit_1_text' + variant.id"
                            />

                            <!-- Katalog Benefit 2 Text -->
                            <autosave-text-field
                                    :label="__('product-texts.form.catalogue_benefit_2_text')"
                                    :product-variant-id="variant.id"
                                    :text="getText(variant, 'TYPE_CATALOGUE_BENEFIT_2')"
                                    :id="getId(variant, 'TYPE_CATALOGUE_BENEFIT_2')"
                                    :placeholder="getText(product, 'TYPE_CATALOGUE_BENEFIT_2')"
                                    type="3"
                                    :textarea="true"
                                    :loading="loadingField"
                                    @text-edited="save"
                                    :key="'catalogue_benefit_2_text' + variant.id"
                            />

                            <!-- Katalog Benefit 3 Text -->
                            <autosave-text-field
                                    :label="__('product-texts.form.catalogue_benefit_3_text')"
                                    :product-variant-id="variant.id"
                                    :text="getText(variant, 'TYPE_CATALOGUE_BENEFIT_3')"
                                    :id="getId(variant, 'TYPE_CATALOGUE_BENEFIT_3')"
                                    :placeholder="getText(product, 'TYPE_CATALOGUE_BENEFIT_3')"
                                    type="4"
                                    :textarea="true"
                                    :loading="loadingField"
                                    @text-edited="save"
                                    :key="'catalogue_benefit_3_text' + variant.id"
                            />

                            <!-- Online Text -->
                            <autosave-text-field
                                    :label="__('product-texts.form.online_text')"
                                    :product-variant-id="variant.id"
                                    :text="getText(variant, 'TYPE_ONLINE_TEXT')"
                                    :id="getId(variant, 'TYPE_ONLINE_TEXT')"
                                    :placeholder="getText(product, 'TYPE_ONLINE_TEXT')"
                                    type="5"
                                    :textarea="true"
                                    :loading="loadingField"
                                    @text-edited="save"
                                    :key="'online_text' + variant.id"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="col-sm-12">
            <div class="alert alert-success">
                <i class="fa fa-spinner fa-spin fa-fw"></i>
                <span>{{ __('product-texts.loading') }}</span>
            </div>
        </div>
    </div>
</template>
